import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import {CardActions} from '@material-ui/core';
import ReactsCard from "../components/ui/ReactsCard";
import {Navigate, useParams} from "react-router-dom";
import {WithOrganization} from "../components/organizations/organization-context";
import {CsvExport} from "../components/_shared/CSVExport";
import {getGuestStatus, getProvider, getProviderGuests} from "../api/pro-guest-functions";
import {useNotification} from "../components/ui/notification/NotificationProvider";
import {run, useQuery} from "../utils/function-util";
import {Provider} from "../models/pro-guest.models";
import {useApiNotification} from "../components/ui/ApiNotificationProvider";
import {GuestsBrowserSimple} from "../components/pro-guest/shared/guests/GuestsBrowserSimple";
import {useCapability} from "../auth/CapabilityContext";
import {Roles} from "../auth/roles";


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
        justifyContent: 'flex-end'
    }
}));


const ProviderGuests: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const query = useQuery();
    const folderId = query.get('folderId');
    const {providerId} = useParams<{providerId: string}>();
    const [provider, setProvider] = useState<Provider>();
    const {pushError} = useNotification();
    const {handleError} = useApiNotification();
    const {hasRole} = useCapability();
    const isAdmin = hasRole(Roles.ADMIN);


    useEffect(run(
        () => getProvider(+(providerId as string)),
        setProvider,
        handleError
    ), [providerId]);

    if (!folderId || !providerId) {
        const redirectUrl = `/pro-guests/providers/${providerId}/guests?folderId=${folderId}`;
        return <Navigate to={redirectUrl} replace={false} />;
    }

    if (!isAdmin) {
        return  <Navigate to={`/organization-units`} replace={false} />;
    }

    const guestsCsvContentBuilder = async () => {
        const guests = await getProviderGuests(provider!.userId, true);

        const data = guests.map((g: any) => [
            g.firstName,
            g.lastName,
            g.email,
            t(`ProGuest.Guests.Table.Status.${getGuestStatus(g)}`)
        ]);

        const headers = [
            t(`_Common.Labels.FirstName`),
            t(`_Common.Labels.LastName`),
            t(`_Common.Labels.Email`),
            t('ProGuest.Guests.Table.Headers.Status')
        ]
        return {data, headers};
    }

    return (
        <ReactsCard title={t('ProGuest.ProviderGuests.Title', provider)} className={classes.root}>
            <CardActions className={classes.action}>
                <CsvExport
                    contentBuilder={guestsCsvContentBuilder}
                    filenameBuilder={async () => `${t(`ProGuest.ProviderGuests.ExportFilename`, provider)}.csv`}
                    onError={(message: any) => pushError({message})}
                >
                    {t('_Shared.CSV.Export')}
                </CsvExport>
            </CardActions>
            <GuestsBrowserSimple organizationId={currentOrganization.id}
                                 folderId={folderId}
                                 groupId={provider?.ownGroupId}
                                 refresh={0}
            />
        </ReactsCard>
    );
};

export default ProviderGuests;
